import React, { useState } from "react";
import { Grid } from "@mui/material";
import LazySection from "common/lazySection";
import Deposit from "./Deposit";
import TableHistory from "./TableHistory";

const quickAmounts = [10000000, 50000000, 100000000, 500000000];

const DepositModule = () => {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  const handleQuickSelect = (value) => {
    setAmount(value);
  };

  return (
    <LazySection>
      <Grid container spacing={4}>
        <Deposit />
        <TableHistory />
      </Grid>
    </LazySection>
  );
};

export default DepositModule;
